let readyResolve!: () => void;
export const apiReady = new Promise<void>((res) => (readyResolve = res));
export const setApiReady = () => readyResolve();
